import HeartIcon from "assets/svg/heart.svg";
import PlusIcon from "assets/svg/plus_radial.svg";
import RingIcon from "assets/svg/ring.svg";
import PaperIcon from "assets/svg/paper.svg";

import PhoneIcon from "assets/svg/phone.svg";
import EyeIcon from "assets/svg/eye.svg";
import SmartPhoneIcon from "assets/svg/smartphone.svg";
import PencilUsedIcon from "assets/svg/pencil-used.svg";

export const data = [
  {
    type: "individual",
    icon: <HeartIcon />,
    text: `İlgilendiğin ilanı <span>favori</span> listene kaydet! Listeni dilediklerinle paylaş.`,
  },
  {
    type: "individual",
    icon: <PlusIcon />,
    text: `Yılda 2 ilanını <span>ücretsiz olarak</span> Emlakjet’te yayınla, ilanını hızlıca alıcısıyla buluştur.`,
  },
  {
    type: "individual",
    icon: <RingIcon />,
    text: `Kriterlerine uygun <span>yeni</span> ilanlardan herkesten önce sen haberdar ol, fırsatları kaçırma!`,
  },
  {
    type: "individual",
    icon: <PaperIcon />,
    text: `Emlak piyasasıyla ilgili son <span>haberleri</span> ilk sen öğren.`,
  },
  {
    type: "corporate",
    icon: <PhoneIcon />,
    text: `Türkiye’de <span>ilk dijital asistan</span> hizmeti olan ücretsiz Jethat ile aramalarınızı kaçırmayın.`,
  },
  {
    type: "corporate",
    icon: <EyeIcon />,
    text: `<span>Vitrin</span> özelliği sayesinde ilanlarınız en önde olsun, daha çok telefon ve görüntüleme alın.`,
  },
  {
    type: "corporate",
    icon: <SmartPhoneIcon />,
    text: `Kolay kullanılabilir ara yüze sahip, mobil uyumlu <span>özel web siteniz</span> ile tanıtımızı yapın.`,
  },
  {
    type: "corporate",
    icon: <PencilUsedIcon />,
    text: `İlan hakkınızı azaltmadan, sınırsız şekilde, ilanlarınız üzerinde <span>düzenlemeler</span> yapın.`,
  },
];
